import { domToReact } from 'html-react-parser';
import { ISetAuthenticationError, ISetPKCEStatus } from '.';
import { COMMON_COMPONENTS, PAGE_NAME } from '../AEM/constants';
import { ISchedulePayments } from '../API/models/PaymentApiModels';
import { AccessTokenDetails } from '../API/models/PKCEAPIModels';
import { IAPIHeaders } from '../API/utils';
import { BINDER_PAYMENT_STATUS } from '../constants/binderPayment/binderMakePaymentConstants';
import {
  ALERT_TYPES,
  DELETE_WALLET_ERROR_TYPES,
  USER_TYPES,
  ORIGIN_TYPES,
  MEMBER_CONVERSION_TYPES,
  PLAN_TYPES,
} from '../constants/common';
import {
  MEMBER_DERIVED_LOB,
  MEMBER_SOURCE_SYSTEM_NAME,
  MEMBER_PRODUCT_TYPE,
  MEMBER_DATA_SOURCE,
  MEMBER_LINE_OF_BUSINESS,
  MEMBER_CORPORATE_CODE,
} from '../constants/memberConstants';
import {
  PAYMENT_STATUS,
  PAYMENT_TYPES,
} from '../constants/recentPaymentConstants';
// import { IRetailLoginResponse } from '../customHooks/useLoginNavigation/useLoginNavigation';
import { ISESSION_DATA } from '../helpers/storeHelper';
import { API_STATUS_TYPES } from './constants';

export type ISetApiStatus = (_statusType: string, _Action: string) => void;
export interface IAppContextValue {
  paymentDetails: IPaymentDetails;
  memberDetails: IMemberDetails;
  listScheduledOneTimePayments: IOneTimeSchedulePayment;
  selectedScheduledTransaction: IScheduledTransaction;
  billDetails: IBillsList;
  loaderDetails: ILoaderDetails;
  authDetails: ITokenDetails;
  immediatePayDetails: IImmediatePaymentDetails;
  oneTimePaymentErrors: IOneTimePaymentErrors;
  scheduledEmailErrors: IScheduledEmailErrors;
  scheduleOneTimePaymentDetails: IScheduleOneTimePaymentDetails;
  autoPaymentDetails: IGetAutoPaymentDetails;
  binderPayNowLoginDetails: IBinderPayNowLoginDetails;
  binderSchedulePaymentResponse: IBinderSchedulePayment;
  binderImmediatePaymentResponse: IBinderImmediatePayment;
  applicantBinderDetails: IApplicantBinderDetailsResponse;
  binderBillDetails: IBinderBillDetails;
  binderPaymentMethod: IBinderPaymentMethod;
  binderPaymentDetails: IBinderPaymentDetails;
  autopayBinderPaymentMethod: IAutopayBinderPaymentMethod;
  setPaymentDetails: (_paymentDetails: IPaymentDetails) => void;
  setMemberDetails: (_memberDetails: IMemberDetails) => void;
  setListScheduledOneTimePayments: (
    _listScheduledOneTimePayments: IOneTimeSchedulePayment,
  ) => void;
  setAutoPaymentDetails: (_autoPaymentDetails: IGetAutoPaymentDetails) => void;
  setSelectedScheduledTransaction: (
    _selectedScheduledTransaction: IScheduledTransaction,
  ) => void;
  showLoader: (_message?: string) => void;
  hideLoader: () => void;
  setBillDetails: (_billsList: IBillsList) => void;
  setAuthDetails: (_authDetails: ITokenDetails) => void;
  setImmediatePayDetails: (
    _immediatePayDetails: IImmediatePaymentDetails,
  ) => void;
  setScheduleOneTimePaymentDetails: (
    _scheduleOneTimePaymentDetails: IScheduleOneTimePaymentDetails,
  ) => void;
  resetContext: () => void;
  hydrateStore: (_billsResponseData: IBillResponseAndSessionData) => void;
  isHydrating: boolean;
  retrieveStateCodeFromUrl: () => void;
  stateCode: string;
  setAPIStatus: ISetApiStatus;
  walletsData: IWalletsData;
  setWalletsData: (_walletsData: IWalletsData) => void;
  walletAlertDetails: IWalletAlertDetails;
  setWalletAlertDetails: (
    _walletConfirmationDetails: IWalletAlertDetails,
  ) => void;
  fetchWallets: (_fetchWallet: IFetchWallet) => void;
  fetchBinderWallets: (_fetchBinderWallet: IFetchWallet) => void;
  APIStatus: IAPIStatus;
  setPaymentMethodOptions: (__paymentMethodOptions: Array<string>) => void;
  paymentMethodOptions: Array<string>;
  scheduledMaintenanceDetails: IScheduledMaintenanceDetails;
  setScheduledMaintenanceDetails: (
    _scheduledMaintenanceDetails: IScheduledMaintenanceDetails,
  ) => void;
  language: string;
  paymentApiType: PAYMENT_API_TYPE;
  setPaymentApiType: (_paymentApiType: PAYMENT_API_TYPE) => void;
  memberEmail: IActiveUserEmailResponse;
  setMemberEmail: (_memberEmail: IActiveUserEmailResponse) => void;
  setOneTimePaymentErrors: (
    _oneTimePaymentErros: IOneTimePaymentErrors,
  ) => void;
  setScheduledEmailErrors: (
    _scheduledEmailErrors: IScheduledEmailErrors,
  ) => void;
  isBrokerUserWithAutopayFailed: boolean;
  setIsBrokerUserWithAutopayFailed: (
    _isBrokerUserWithAutopayFailed: boolean,
  ) => void;
  globalTechnicalDifficulty: IGlobalTechnicalDifficulty;
  setGlobalTechnicalDifficulty: (
    _globalTechnicalDifficulty: IGlobalTechnicalDifficulty,
  ) => void;
  resetWalletAlertDetails: () => void;
  setAutoPayPaymentMethods: (
    _autoPayPaymentMethods: IAutoPayPaymentMethods,
  ) => void;
  autoPayPaymentMethods: IAutoPayPaymentMethods;
  autopayAlertDetails: IAutopayAlertDetails;
  setAutopayAlertDetails: (
    _AutopayConfirmationDetails: IAutopayAlertDetails,
  ) => void;
  resetAutopayAlertDetails: () => void;
  userDetails: IUserDetails;
  setUserDetails: (_userDetails: IUserDetails) => void;
  accessTokenData: AccessTokenDetails;
  setAccessTokenData: (_accessTokenDetails: AccessTokenDetails) => void;
  memberAuthenticationError: IAuthenticationError; // state
  setAuthenticationError: ISetAuthenticationError; // function to catch errors
  PKCEState: IPKCEStatus;
  setPKCEStatus: ISetPKCEStatus;
  setBinderPayNowLoginDetails: (
    _binderPayNowLoginDetails: IBinderPayNowLoginDetails,
  ) => void;
  setBinderSchedulePaymentResponse: (
    _binderSchedulePaymentResponse: IBinderSchedulePayment,
  ) => void;
  setBinderImmediatePaymentResponse: (
    _binderImmediatePaymentResponse: IBinderImmediatePayment,
  ) => void;
  setBinderBillDetails: (_binderBillDetails: IBinderBillDetails) => void;
  setApplicantBinderDetails: (
    _applicantBinderDetails: IApplicantBinderDetailsResponse,
  ) => void;
  setBinderPaymentMethod: (_binderPaymentMethod: IBinderPaymentMethod) => void;
  setBinderPaymentDetails: (
    _binderPaymentDetails: IBinderPaymentDetails,
  ) => void;
  setAutopayBinderPaymentMethod: (
    _autopayBinderPaymentMethod: IAutopayBinderPaymentMethod,
  ) => void;
  setSelectedTabUrl: (__selectedTabUrl: string) => void;
  selectedTabUrl: string;
  setCaId: (__caId: string) => void;
  caId: string;
  binderPaymentApiType: PAYMENT_API_TYPE;
  setBinderPaymentApiType: (_binderPaymentApiType: PAYMENT_API_TYPE) => void;
  displayAutopayDetails: boolean;
  setDisplayAutopayDetails: (_displayAutopayDetails: boolean) => void;
  binderPayNowTransactionId: string;
  setBinderPayNowTransactionId: (__binderPayNowTransactionId: string) => void;
  showConversionModal: boolean;
  setShowConversionModal: (_showConversionModal: boolean) => void;
  readOnlyView: boolean;
  setReadOnlyView: (_readOnlyView: boolean) => void;
  autopayEnrolment: IHPSEnrolment;
  setAutopayEnrolment: (_autopayEnrolment: IHPSEnrolment) => void;
  limitFunctionality: boolean;
  setLimitFunctionality: (_limitFunctionality: boolean) => void;
  showOldConversionModal: boolean;
  setOldConversionModal: (_showOldConversionModal: boolean) => void;
  selectedRecentPayment: IRecentPaymentProps;
  setSelectedRecentPayment: (
    _selectedRecentPayment: IRecentPaymentProps,
  ) => void;
  showAutopaySetupModal: boolean;
  setShowAutopaySetupModal: (_showAutopaySetupModal: boolean) => void;
  showEconsentModal: boolean;
  setShowEconsentModal: (_showEconsentModal: boolean) => void;
  menuItemsConfiguration: IMenuItemsConfiguration;
  setMenuItemsConfiguration: (
    _menuItemsConfiguration: IMenuItemsConfiguration,
  ) => void;
  isLoadingAfterLogin: boolean; // used to load the Autopay setup modal after login
  setIsLoadingAfterLogin: (_isLoadingAfterLogin: boolean) => void;
  planSelected: string;
  setPlanSelected: (_planSelected: PLAN_TYPES) => void;
  showChangeViewPlanOptions: boolean;
  setChangeViewPlanOptions: (showChangeViewPlanOptions: boolean) => void;
  hasGovtScheduledPayments: boolean;
  setHasGovtScheduledPayments: (_hasGovtScheduledPayments: boolean) => void;
  schedulePaymentCount: number;
  setSchedulePaymentCount: (_schedulePaymentCount: number) => void;
  isMedsupAutopayLoaded: boolean; //used to call getAutopayment API only once for Medsup users with amount due is less than or equeal to zero
  setIsMedsupAutopayLoaded: (_isMedsupAutopayLoaded: boolean) => void;
  brokerAutopayPaymentMethod: string; // used to save payment method used by broker when setting-up autopay
  setBrokerAutopayPaymentMethod: (_brokerAutopayPaymentMethod: string) => void;
  emailConfirmationStatus: IEmailConfirmationStatus;
  setEmailConfirmationStatus: (
    _emailConfirmationStatus: IEmailConfirmationStatus,
  ) => void;
  fundingAccountDetailsForBroker: IFundingAcountDetailsForBroker;
  setFundingAccountDetailsForBroker: (
    _fundingAccountDetailsForBroker: IFundingAcountDetailsForBroker,
  ) => void;
  referenceCodeForBroker: string;
  setReferenceCodeForBroker: (_referenceCodeForBroker: string) => void;
  formatedDate: string;
  setFormatedDate: (_formatedDate: string) => void;
  errorCodeForValidateBroker: string;
  setErrorCodeForValidateBroker: (_errorCodeForValidateBroker: string) => void;
}

type AEMContent = ReturnType<typeof domToReact>;

interface IAEMContentResponseStatus {
  isLoaded?: boolean;
  error?: string;
}

interface AEMContentImage {
  altText: string;
  imgUrl: string;
}

export interface IHistoryFilter {
  lengthOfTime?: string;
  lastEighteenMonths?: string;
  lastSixMonths?: string;
  lastThreeMonths?: string;
  applyFiltersButton?: string;
  clearAllFiltersButton?: string;
  fromDate?: string;
  toDate?: string;
  closeButton?: string;
  dateRange?: string;
  billingHistoryFilters?: string;
  coverageLabel?: string;
  yearToDateLabel?: string;
  dataAvailabilityMessage?: string;
  invalidStartDate?: string;
  invalidEndDate?: string;
}

export interface IPaymentDetailsAEMContent extends IAEMContentResponseStatus {
  label: {
    sectionHeader: string;
    currentBalance: string;
    minimumDue: string;
    latePaymentTitle: string;
    upcomingPaymentTitle: string;
    makePaymentButton: string;
    paymentDueDate: string;
    noUpcomingPaymentLabel: string;
    currentPayment?: string;
    expiringPolicy?: string;
    scheduledPaymentHeader?: string;
    paymentScheduledLabel?: string;
    automaticPaymentsLabel?: string;
    onLabel?: string;
    manageLink?: string;
    editLink?: string;
    offLabel?: string;
    newVersionButton?: string;
    coverageUntil?: string;
    noUpcomingBills?: string;
    nextAutopayBillPayment?: string;
    newPortalOverlayHeader?: string;
    newPortalOverlayBody?: string;
    cancelButton?: string;
    nonAutoBillPayTitle?: string;
    nonAutoBillPayClose?: string;
    nonAutoBillPayBody?: string;
    paidLabel?: string;
    noCurrentBalance?: string;
    pageHeading?: string;
    amountLabel?: string;
    confirmationNumber?: string;
    scheduledLabel?: string;
    detailsLabel?: string;
    declinedLabel?: string;
    accountChargedLabel?: string;
    appliedToBillLabel?: string;
    noRecentPaymentMessage?: string;
    cancelledLabel?: string;
    returnedLabel?: string;
    autopayModalTitle?: string;
    autopayModalDescription?: string;
    autopayModalCloseButton?: string;
    autopayModalContinueButton?: string;
    expiredPolicy?: string;
    govtAutoPayModalTitle?: string;
    govtAutoPayModalDescription?: string;
    govtAutoPayModalCloseButton?: string;
    govtAutoPayModalContinueButton?: string;
    recurringACHLabel?: string;
    ezBluePaymentLabel?: string;
    paymentMethod?: string;
    autoPayUpdateMsg?: string;
    subtitle?: string;
    intro?: string;
    oneTimeOnlinePaymentText?: string;
    oneTimeOnlinePaymentUrl?: string;
    automaticPaymentsText?: string;
    automaticPremiumPaymentsUrl?: string;
    rrbBenefitsText?: string;
    rrbBenefitsWithdrawalUrl?: string;
    moreDetailsText?: string;
    premiumPaymentsFooterLinkUrl?: string;
  };
  inlineError: {
    paymentOverdue: string;
  };
  alert: {
    latePaymentAlert: string;
    paymentProcessing: string;
    governmentCurrentBalanceWarningMsg?: string;
    mapdUnableToProcess?: string;
    pdpUnableToProcess?: string;
    govtSchedulePaymentMsg?: string;
    mapdOrPdpUnableToProcess?: string;
    autoBillPayDisabledHeading?: string;
    autoBillPayDisabledBodyCopy?: string;
  };
}

export interface IReviewPaymentAemLabel {
  cancelLink: string;
  editLink: string;
  paymentAmountLabel: string;
  paymentDateLabel: string;
  paymentMethodLabel: string;
  reviewPaymentSubTitle: string;
  reviewPaymentTitle: string;
  sectionHeader: string;
  submitButton: string;
  serverDate: string;
}

export interface IReviewPaymentDetails extends IReviewPaymentAemLabel {
  continueButton: string;
  loaderMessage: string;
  paymentCompleteConfirmation: string;
  paymentScheduledConfirmation?: string;
  paymentUpdatedConfirmation?: string;
  singlePaymentCheckBox: string;
  paymentAgreementCheckBox: string;
  paymentAccountVelocityForGovUser?: string;
  paymentProcessingTimeMsg?: string;
  govIsAccountOrRoutingNumberInvalidLabel?: string;
  disclosurePaymentCheckbox?: string;
  brokerPaymentCheckbox?: string;
}
export interface IReviewPaymentDetailsAEMContent
  extends IAEMContentResponseStatus {
  label: IReviewPaymentDetails;
  inlineError: {
    inlineCheckBoxError: string;
  };
  alert: {
    caPaymentAccountBlocked: string;
    caPaymentAccountVelocityReached: string;
    caFundingAccountCardExpired: string;
    caInvalidAccountOrRoutingNumber: string;
    caUnsupportedCard: string;
    caCommercialCreditCard: string;
    caEmailMinimumLength: string;
    caEmailMinimumLengthGov: string;
    caEmailMaximumLengthGov: string;
    caEmailMaximumLength: string;
    memberEmailInvalidFormatErrorMessageIL?: string;
    memberEmailInvalidFormatErrorMessageTX?: string;
    memberEmailInvalidFormatErrorMessageNM?: string;
    memberEmailInvalidFormatErrorMessageOK?: string;
    memberEmailInvalidFormatErrorMessageMT?: string;
    memberEmailLengthValidationErrorMessageIL?: string;
    memberEmailLengthValidationErrorMessageTX?: string;
    memberEmailLengthValidationErrorMessageNM?: string;
    memberEmailLengthValidationErrorMessageOK?: string;
    memberEmailLengthValidationErrorMessageMT?: string;
    govMemberEmailInvalidFormatErrorMessageIL?: string;
    govMemberEmailInvalidFormatErrorMessageTX?: string;
    govMemberEmailInvalidFormatErrorMessageNM?: string;
    govMemberEmailInvalidFormatErrorMessageOK?: string;
    govMemberEmailInvalidFormatErrorMessageMT?: string;
    govMemberEmailLengthValidationErrorMessageIL?: string;
    govMemberEmailLengthValidationErrorMessageTX?: string;
    govMemberEmailLengthValidationErrorMessageNM?: string;
    govMemberEmailLengthValidationErrorMessageOK?: string;
    govMemberEmailLengthValidationErrorMessageMT?: string;
    errorInvalidEmailFormatMobile: string;
    errorMaximumEmailLengthMobile: string;
    fundingTokenExpiredForGovUser: string;
  };
}

export interface IReviewBinderPaymentPage extends IReviewPaymentAemLabel {
  autoPayOn: string;
  autoPayOff: string;
  autoPayHeading: string;
  autoPayLabel: string;
  autoNextPaymentLabel: string;
  balancePaidMessage: string;
  singlePaymentAuthorization: string;
  autoPaymentAuthorization: string;
  confirmationNumberLabel: string;
  paymentSubmittedMessage: string;
  redirectionMessage: string;
  printText: string;
  printTooltipText: string;
  econsentCheckboxLabel: string;
}
export interface IReviewBinderPaymentDetailsAEMContent
  extends IAEMContentResponseStatus {
  label: IReviewBinderPaymentPage;
  inlineError: {
    checkboxError: string;
  };
  alert: {
    caPaymentAccountBlockedMessage: string;
    caFundingAccountCardExpiredMessage: string;
    caAccountOrRoutingNumberInvalidMessage: string;
    caCommercialFundingAccountMessage: string;
    caCardDetailsInvalidOrNotSupportedMessage: string;
    caEmailInvalidFormatErrorMessage: string;
    caPaymentAccountVelocityReachedMessage: string;
    caEmailLengthValidationErrorMessage: string;
    memberEmailInvalidFormatErrorMessageIL: string;
    memberEmailInvalidFormatErrorMessageTX: string;
    memberEmailInvalidFormatErrorMessageNM: string;
    memberEmailInvalidFormatErrorMessageOK: string;
    memberEmailInvalidFormatErrorMessageMT: string;
    memberEmailLengthValidationErrorMessageIL: string;
    memberEmailLengthValidationErrorMessageTX: string;
    memberEmailLengthValidationErrorMessageNM: string;
    memberEmailLengthValidationErrorMessageOK: string;
    memberEmailLengthValidationErrorMessageMT: string;
  };
}
export interface IMemberValidationAEMContents
  extends IAEMContentResponseStatus {
  alert: {
    noBillAvailable: string;
    loadMemberLoginError: string;
    mtNoActivePolicies: string;
  };
  label: {
    titleLoggedInMemberEnteredIncorrectInformation: string;
    bodyLoggedInMemberEntersIncorrectInformation: string;
    buttonLoggedInMemberEntersIncorrectInformation: string;
    caTitleLoggedInMemberEnteredIncorrectInfo: string;
    caBodyTermedMemberAttemptsLogIn: string;
    caButtonLoggedInMemberEnteredIncorrectInformation: string;
    caTitleTermedMemberAttemptsLogIn: string;
    caBodyTermedMemberAttemptsLogIn1: string;
    caButtonTermedMemberAttemptsLogIn: string;
    titleTermedMemberAttemptsLogIn: string;
    bodyTermedMemberAttemptsLogIn: string;
    buttonTermedMemberAttemptsLogIn: string;
    continueButton: string;
    dateOfBirth: string;
    exitLink: string;
    memberID: string;
    memberIDInformation: string;
    orLabel: string;
    policyInformation: string;
    zipCode: string;
    paymentTermAccept: string;
    browserVersionDisclaimer: string;
    serverDate: string;
    memberAccountLogin: string;
    oneTimePayment: string;
    bannerHeading: string;
    bannerMessage: string;
  };
  inlineError: {
    invalidDOBMonth: string;
    invalidDOBMonthYear: string;
    invalidDOBYear: string;
    invalidMemberID: string;
    invalidZip: string;
  };
  image: {
    card: AEMContentImage;
    cardToolTip: AEMContentImage;
  };
  placeholder: {
    dateOfBirthPlaceholder: string;
  };
}

export interface IAllPaymentDetailsAEMContent
  extends IAEMContentResponseStatus {
  label: {
    sectionHeader: string;
    allPaymentTitle: string;
    paymentDueDate: string;
    expiringPolicy?: string;
    automaticPaymentsLabel?: string;
    onLabel?: string;
    manageLink?: string;
    offLabel?: string;
    coverageUntil?: string;
    nextAutopayBillPayment?: string;
    newPortalOverlayHeader?: string;
    newPortalOverlayBody?: string;
    cancelButton?: string;
    nonAutoBillPayTitle?: string;
    nonAutoBillPayClose?: string;
    nonAutoBillPayBody?: string;
    paidLabel?: string;
    expiredPolicy?: string;
    paymentMethod?: string;
    autoPayUpdateMsg?: string;
  };
  alert: {
    selectOnePayment: string;
  };
  inlineError: {
    latePayment: string;
    paymentAlertWarning: string;
    scheduledPaymentIndicator?: string;
  };
}

export interface IHPSEnrolment {
  showAutopayModal: boolean;
  isNewlyConverted: boolean;
  isHPSAutopayEnabled: boolean;
  openAutopayDrawer: boolean;
}

export interface IHeaderCommonAEMContents extends IAEMContentResponseStatus {
  image: {
    pageLogo: {
      altText: string;
      imgUrl: string;
      linkUrl: string;
    };
  };
  label: {
    espanolText: string;
    exitText: string;
    menu: string;
    languageAssistance: string;
    myAccount: string;
    logout: string;
    exitLabel: string;
    newMemberPortal: string;
    improvedFeatures: string;
    oldVersionButton: string;
    newVersionButton: string;
    termedMember: string;
    serverDate: string;
    changeViewPlanLabel: string;
    govPlanOption: string;
    ifmPlanOption: string;
    brokerName: string;
    brokerId: string;
    memberId: string;
  };
}

export interface ICancelCommonAEMContents extends IAEMContentResponseStatus {
  label: {
    secondaryButton: string;
    primaryButton: string;
    title: string;
    description: string;
    stayOnPageLabel?: string;
  };
}

export interface IEconsentModal extends IAEMContentResponseStatus {
  label: {
    title: string;
    description: string;
    primaryButton: string;
  };
}

export interface IAutopayEnrolmentAEMContents
  extends IAEMContentResponseStatus {
  label: {
    secondaryButton: string;
    primaryButton: string;
    title: string;
    firstDescription: string;
    returnDescription: string;
    skipButton: string;
    stayOnPageLabel?: string;
  };
}

export interface IFooterCommonAEMContents extends IAEMContentResponseStatus {
  label: {
    footerDetails: AEMContent;
  };
}

export interface IPaymentTermsAEMContents extends IAEMContentResponseStatus {
  label: {
    paymentTerm: string;
    paymentTermAccept: string;
    submitButton: string;
    termsAndCondition: AEMContent;
    cancel: string;
    loaderMessage: string;
    paymentCompleteConfirmation: string;
    agree: string;
  };
  alert: {
    scrollDown: string;
    addressError: string;
  };
  inlineError: {
    addressError: string;
  };
}

export interface IPaymentCompleteAEMContents extends IAEMContentResponseStatus {
  label: {
    doneText: string;
    dialogEmailEnterText: string;
    dialogEmailInputLabel: string;
    emailText: string;
    paymentCompleted: string;
    paymentCompletedWarning: string;
    paymentConfirmationNumber: string;
    paymentDate: string;
    paymentMethod: string;
    paidText: string;
    print: string;
    printTooltipText: string;
    questionsConcerns: string;
    questionsConcernsAnswer: string;
    bannerLabel: string;
    returnToPayments: string;
    submitActionText?: string;
    cancelActionText?: string;
    dialogTitle?: string;
    cutoffText?: string;
    serverDate: string;
    logout: string; // todo - add logout for other pages in payment completed , added optional now
    memberIdHeading?: string;
    paymentProcessingTimeMsg?: string;
    returnToPaymentHistoryButton?: string;
    sendConfirmationTextMessage?: string;
    yesSendEmail?: string;
    mailSentSuccess?: string;
    mailSentFailure?: string;
    tryAgainMail?: string;
  };
  inlineError: {
    emailErrorMessage: string;
  };
}

export interface ICancelledPaymentConfirmationAEMContents
  extends IAEMContentResponseStatus {
  label: {
    paymentCompleted: string;
    editPaymentLabel: string;
    paymentDate: string;
    paymentAmountLabel: string;
    print: string;
    printTooltipText: string;
    anotherPaymentLabel: string;
    emailText: string;
    returnToPayments: string;
    paymentConfirmationNumber: string;
    questionsConcernsAnswer: string;
    questionsConcerns: string;
    paymentMethod: string;
    bannerLabel: string;
  };
}

export interface IScheduledPaymentConfirmationAEMContents
  extends IAEMContentResponseStatus {
  label: {
    paymentCompleted: string;
    editPaymentLabel: string;
    paymentDate: string;
    paidText: string;
    print: string;
    printTooltipText: string;
    bannerLabel: string;
    emailText: string;
    returnToPayments: string;
    paymentConfirmationNumber: string;
    questionsConcernsAnswer: string;
    questionsConcerns: string;
    paymentMethod: string;
  };
}

export interface IAutoPaymentSettingsAEMContents
  extends IAEMContentResponseStatus {
  inlineError: {
    paymentMethodInlineError: string;
    inlineCheckBoxError: string;
    accountHolderEmailInlineError: string;
    invalidNickname: string;
    duplicateNickname: string;
  };
  label: {
    cancelLabel: string;
    confirmLabel: string;
    emailMessage: string;
    emailLabel: string;
    nextPaymentDateMessage: string;
    nextPaymentDateLabel: string;
    billsAppliedLabel: string;
    nextPaymentAmountLabel: string;
    firstAutoBillPayDateLabel: string;
    firstAutoBillPayDateDisclaimer: string;
    savePaymentMethodLabel: string;
    newBankAccountLabel: string;
    bankAccountMessage: string;
    autopayToggleOnLabel: string;
    autopayToggleOffLabel: string;
    paymentMethodLabel: string;
    manageAutopayMessage: string;
    autopaymentTitleLabel: string;
    autopayManageSettingLabel: string;
    selectPaymentMethodLabel: string;
    latePaymentMessage: string;
    oneTimeLatePaymentAmountLabel: string;
    noEmailFoundMessage: string;
    issueRetrievingEmailMessage: string;
    serverDate: string;
    recurringPaymentCheckBox: string;
    recurringPaymentBinderPayLaterCheckbox: string;
    bankAccountHolder: string;
    bamemailAddressHeading: string;
    bamemailMessage: string;
    accountHolderEmailMessage: string;
    abpcommunicationHeading: string;
    nonMemberBankActChk: string;
    nicknameLabel: string;
    applicantEmailLabel: string;
    newVersionButton: string;
    newVersionMessage: string;
    noUpcomingBills: string;
    changePaymentMethodLabel: string;
    freezePeriodAlertMsg: string;
    lockdownPeriodAlertMsg: string;
    termedMemberAutopayOnMessage: string;
    termedMemberAutopayOffMessage: string;
    autoBillPayAppliedPoliciesLabel: string;
    disclosureAutopayCheckbox: string;
    brokerAutopayCheckbox: string;
    titleAutoBillPayTerms: string;
    bodyAutoBillPayTerms: string;
  };
  alert: {
    autoPaymentTurnedOffAlert: string;
    autoPaymentTurnedOnAlert: string;
    automaticPaymentsNoBalance: string;
    autoPaymentsOneBalance: string;
    autoPaymentsNextMonth: string;
    autoPaymentsLatePayments: string;
    invalidDataEntry: string;
    paymentAccountBlocked: string;
    errorLoadAutoPayEmail: string;
    noAutoPayEmail: string;
    autoPayOnAlert: string;
    autoPayOffAlert: string;
    autoPayUpdateAlert: string;
    autopayActHolderEmailAlert: string;
    autoBillPayDelayed: string;
    caEmailMinimumLength: string;
    caEmailMaximumLength: string;
    memberEmailMinimumLengthIL: string;
    memberEmailMaximumLengthIL: string;
    memberEmailMinimumLengthTX: string;
    memberEmailMaximumLengthTX: string;
    memberEmailMinimumLengthNM: string;
    memberEmailMaximumLengthNM: string;
    memberEmailMinimumLengthOK: string;
    memberEmailMaximumLengthOK: string;
    memberEmailMinimumLengthMT: string;
    memberEmailMaximumLengthMT: string;
    attentionCATitle: string;
    errorInvalidEmailFormatMobile: string;
    errorMaximumEmailLengthMobile: string;
    autopayAssistanceAlert: string;
  };
}
export interface IAutoPaymentSuccessAEMContents
  extends IAEMContentResponseStatus {
  alert: {
    autopayEditAlert: string;
    brokerAutopayAssistanceAlert: string;
    mailSentSuccess: string;
    mailSentFailure: string;
  };
  label: {
    autopaySuccessTitle: string;
    autoBillPayAppliedPoliciesLabel: string;
    returnToPayments: string;
    sectionHeader: string;
    autopaySuccessSectionHeader: string;
    autoBillPayActivationHeader: string;
    autoBillPayActivationMessage: string;
    autoBillPayConfirmationEmail: string;
    autoBillPaySendEmail: string;
    yesSendEmail: string;
    tryAgainMail: string;
    sendConfirmationTextMessage: string;
  };
}

export interface IHealthspringPaymentHistoryAEMContent
  extends IAEMContentResponseStatus {
  label: {
    title: string;
    tableHeader: string;
    showingResults: string;
    newestToOldest: string;
    oldestToNewest: string;
    printButton: string;
  };
}

export interface IPaymentHistoryAEMContent extends IAEMContentResponseStatus {
  label: {
    autoBillPayTooltip: string;
    sectionHeader: string;
    viewResultsLabel: string;
    print: string;
    printTooltipText: string;
    filter: string;
    confirmationLabel: string;
    methodLabel: string;
    processedLabel: string;
    cancelledLabel: string;
    returnedLabel: string;
    scheduledLabel: string;
    declinedLabel: string;
    refundedByCheckLabel: string;
    accountChargedLabel: string;
    appliedToBillLabel: string;
    paymentHistoryFilters: string;
    paymentStatus: string;
    statusCancelled: string;
    statusRefund: string;
    statusReturned: string;
    paymentStatusLabel: string;
    amountPaidLabel: string;
    paginationPreviousText: string;
    paginationNextText: string;
    paginationDropdownText: string;
    noPaymentHistoryMessage: string;
    paymentHistoryUnavailableTitle: string;
    paymentHistoryUnavailableDescription: string;
    lengthOfTime: string;
    lastEighteenMonths: string;
    lastSixMonths: string;
    lastThreeMonths: string;
    lastTwelveMonths: string;
    dataAvailableMsg: string;
    applyFiltersButton: string;
    clearAllFiltersButton: string;
    fromDate: string;
    toDate: string;
    closeButton: string;
    dateRange: string;
    serverDate: string;
    customDates: string;
    dateRangeLabel: string;
    paymentDate: string;
    viewAll?: string;
    editLink?: string;
    lastTwentyFourMonths: string;
    dataAvailableMsgForTwentyFourMonths: string;
    returnedOrReversedStatusHelperLabel?: string;
    paidLabel?: string;
    returnToAllPaymentsLink: string;
    paymentHistoryForLabel: string;
    refundLabel?: string;
    refundVoidedLabel?: string;
    reversedLabel?: string;
    removedLabel?: string;
    reversedStatusHelperLabel?: string;
    removedStatusHelperLabel?: string;
    declinedStatusHelperLabel?: string;
    paymentHistoryMapdTitle: string;
    paymentHistoryPdpTitle: string;
    paymentHistoryMedsupTitle: string;
    accountChargedLabelFilter: string;
    cancelledLabelFilter: string;
    refundLabelFilter: string;
    returnedLabelFilter: string;
    scheduledLabelFilter: string;
    declinedLabelFilter: string;
    appliedToBillLabelFilter: string;
    reversedLabelFilter: string;
    refundVoidedLabelFilter: string;
    removedLabelFilter: string;
    refundedByCheckLabelFilter: string;
    paymentHistoryDisclaimerMessage: string;
    paidVmsHelperText: string;
    achLabel: string;
  };
  inlineError: {
    invalidEndDate: string;
    invalidStartDate: string;
  };
}

export interface IBillingHistoryAEMContent extends IAEMContentResponseStatus {
  label: {
    sectionHeader: string;
    viewResultsLabel: string;
    billedOn: string;
    viewAsSpreadsheet: string;
    filterButton: string;
    detailsButton: string;
    pagination: string;
    nextPage: string;
    prevPage: string;
    noBillsMessage: string;
    serverDate: string;
    paginationPreviousText: string;
    paginationNextText: string;
    paginationDropdownText: string;
    viewDateLabel: string;
    billDetailsHeading: string;
    planName: string;
    paymentDueOn: string;
    billPeriod: string;
    billedPremium: string;
    premiumCollected: string;
    pastDueAmount: string;
    priorBalance: string;
    amountBilled: string;
    currentCharges: string;
    aptcAmount: string;
    adjustments: string;
    fees: string;
    deliveryMethod: string;
    questionsConcerns: string;
    contactCustomerService: string;
    noBillHistoryMessage: string;
    lengthOfTime: string;
    lastEighteenMonths: string;
    lastSixMonths: string;
    lastThreeMonths: string;
    yearToDateLabel: string;
    dataAvailabilityMessage: string;
    applyFiltersButton: string;
    clearAllFiltersButton: string;
    fromDate: string;
    toDate: string;
    closeButton: string;
    dateRange: string;
    billingHistoryFilters: string;
    coverageLabel: string;
    customDates: string;
    expiredPlanBillDetails: string;
    expiringPlanBillDetails: string;
    expiredPlanCard: string;
    expiringPlanCard: string;
    expiredPlanFilter: string;
    expiringPlanFilter: string;
    viewPdfButton: string;
    currentBalance: string;
    paymentsReceived: string;
    pastDueAmountIncluded: string;
    expiredPolicy: string;
    expiredPolicyBillDetails: string;
    viewAll?: string;
    noBillDocumentWarningAlert: string;
    lastThirtySixMonths: string;
    lastTwentyFourMonths: string;
    twentyFourMonthsDataAvailabilityMessage: string;
    thirtySixMonthsDataAvailabilityMessage: string;
    billingHistoryForLabel: string;
    returnToAllPaymentsLink: string;
    paidLabel: string;
    unPaidLabel: string;
    partiallyPaidLabel: string;
    billIssuedOnLabel: string;
    startOfBillPeriodLabel: string;
    billedAmountLabel: string;
    unpaidFilterLabel: string;
    paidFilterLabel: string;
    partiallyPaidFilterLabel: string;
    billingStatusFilterLabel: string;
    billingHistoryMapdTitle: string;
    billingHistoryMedsupTitle: string;
    billingHistoryPdpTitle: string;
  };
  inlineError: {
    invalidEndDate: string;
    invalidStartDate: string;
  };
}

export interface IBillingHistorySpreadsheetAEMContent
  extends IAEMContentResponseStatus {
  label: {
    sectionHeader: string;
    viewAsList: string;
    billingHistorySubHeading: string;
    print: string;
    printTooltipText: string;
    filter: string;
    billPeriod: string;
    priorBalance: string;
    billAmount: string;
    adjustments: string;
    paymentsReceived: string;
    fee: string;
    aptc: string;
    totalAmountDue: string;
    serverDate: string;
    viewDateLabel: string;
    lengthOfTime: string;
    lastThirtySixMonths: string;
    lastEighteenMonths: string;
    lastSixMonths: string;
    lastThreeMonths: string;
    yearToDateLabel: string;
    thirtySixMonthsDataAvailabilityMessage: string;
    dataAvailabilityMessage: string;
    applyFiltersButton: string;
    clearAllFiltersButton: string;
    fromDate: string;
    toDate: string;
    closeButton: string;
    dateRange: string;
    billingHistoryFilters: string;
    noBillHistoryMessage: string;
    expiredPlanTitle: string;
    expiringPlanTitle: string;
    currentCharges: string;
    pastDueAmountIncluded: string;
    billedPremium: string;
    amountBilled: string;
    pastDueAmount: string;
  };
}

export interface IBinderMakePayment extends IAEMContentResponseStatus {
  label: {
    sectionTitle: string;
    cancelLink: string;
    currentBalanceLabel: string;
    paymentTermAccept: string;
    paymentInformationTitle: string;
    paymentInformationDescription: string;
    paymentDateLabel: string;
    paymentAmountLabel: string;
    paymentAmountMessage: string;
    reviewPaymentButtonLabel: string;
    paymentMethodLabel: string;
    billingInfoNote: string;
    selectNewPaymentMethod: string;
    newBankAccount: string;
    newCard: string;
    savePaymentCheckBox: string;
    phoneLabel: string;
    emailLabel: string;
    billingAddressLabel: string;
    confirmBillingMessage: string;
    confirmBillingLabel: string;
    autopayLabel: string;
    autopayHeading: string;
    autopayMessage: string;
    autopayOff: string;
    autopayOn: string;
    samePaymentMethodText: string;
    nextPaymentAmountLabel: string;
    nextPaymentDateLabel: string;
    nextPaymentDateMessage: string;
    autopayEmail: string;
    autopayEmailMessage: string;
    paymentMethodSubmittedText: string;
    serverDate: string;
    nicknameLabel: string;
    paymentProcessedModalButton: string;
    paymentProcessedModalTitle: string;
    paymentProcessedModalDescription: string;
    paymentScheduledModalTitle: string;
    paymentScheduledModalDescriptionHeading: string;
    paymentScheduledModalDescriptionMessage: string;
    paymentScheduledModalCancelButton: string;
    paymentScheduledModalSubmitButton: string;
  };
  alert: {
    cardNotSupported: string;
    invalidDataEntry: string;
    paymentAccountBlocked: string;
    selectBankAccountAlert: string;
    notifyOnAmountChangeAlert: string;
    binderPaymentAdded: string;
    paymentMethodFail: string;
  };
  inlineError: {
    invalidNickname: string;
    duplicateNickname: string;
  };
}

export interface IBinderPayLaterMakePayment extends IAEMContentResponseStatus {
  label: {
    sectionTitle: string;
    cancelLink: string;
    currentBalanceLabel: string;
    remainingBalance: string;
    paymentInformationTitle: string;
    paymentInformationDescription: string;
    paymentDateLabel: string;
    paymentAmountLabel: string;
    paymentAmountMessage: string;
    reviewPaymentButtonLabel: string;
    paymentMethodLabel: string;
    savePaymentCheckBox: string;
    selectNewPaymentMethod: string;
    newCard: string;
    newBankAccount: string;
    autopayLabel: string;
    autopayHeading: string;
    autopayMessage: string;
    autopayOff: string;
    autopayOn: string;
    samePaymentMethodText: string;
    nextPaymentAmountLabel: string;
    nextPaymentDateLabel: string;
    nextPaymentDateMessage: string;
    autopayEmail: string;
    autopayEmailMessage: string;
    paymentMethodSubmittedText: string;
    serverDate: string;
    editPaymentTitle: string;
    selectPaymentAmountLabel: string;
    paymentDetailsTitle: string;
    cancelEditLabel: string;
    nicknameLabel: string;
    otherAmount: string;
    emailAddressLabel: string;
  };
  alert: {
    selectBankAccountAlert: string;
    notifyOnAmountChangeAlert: string;
    paymentMethodFail: string;
    binderPaymentAdded: string;
    cardNotSupported: string;
    invalidDataEntry: string;
    paymentAccountBlocked: string;
    currentScheduledPaymentAlert: string;
    scheduledPaymentInfoAlert: string;
    attentionCaTitle: string;
  };
  inlineError: {
    minimumAmountErrorMsg: string;
    maximumAmountErrorMsg: string;
    invalidNickname: string;
    emailErrorMessage: string;
    duplicateNickname: string;
  };
}
export interface ICancelledConfirmationInterstitialAEMContents
  extends IAEMContentResponseStatus {
  label: {
    paymentCompleteConfirmation: string;
  };
}

export interface IMakePaymentAEMContents extends IAEMContentResponseStatus {
  label: {
    sectionHeader: string;
    editPaymentTitle: string;
    cancelLink: string;
    currentBalance: string;
    minimumDue: string;
    paymentDetailsTitle: string;
    otherAmountLabel: string;
    paymentDateLabel: string;
    paymentAmountLabel: string;
    currentBalanceRadioLabel: string;
    minDueRadioLabel: string;
    reviewPaymentButtonLabel: string;
    paymentMethodLabel: string;
    billingInfoNote: string;
    sectionTitle: string;
    selectPaymentMethodDropDown?: string;
    bankAccountDropDown?: string;
    cardDropDown?: string;
    savePaymentCheckBox?: string;
    serverDate: string;
    invalidDataEntryForGovUser: string;
    paymentAccountBlockedForGovUser: string;
    govtSchedulePaymentWarningHeading?: string;
    bankAccountHolder?: string;
    confirmBankAccountHolderEmail?: string;
    confirmSubscriberEmail?: string;
  };
  alert: {
    cardNotSupported: string;
    invalidDataEntry: string;
    paymentAccountBlocked: string;
    paymentProcessing: string;
    emailNotPresent: string;
    issueWithEmail: string;
    governmentCurrentBalanceWarningMsg?: string;
    govtMedsupImmediatePaymentMsg?: string;
    govtSchedulePaymentWarningMsg?: string;
    attentionCATitle: string;
  };
  inlineError: {
    minimumAmountErrorMsg: string;
    maximumAmountErrorMsg: string;
    moreThanDueAmountErrorMsg: string;
    invalidEmailError?: string;
  };
}

export interface IApplicantBinderPaymentDetailsAEMContent
  extends IAEMContentResponseStatus {
  label: {
    sectionTitle: string;
    instructionMessageLabel: string;
    billingIDLabel: string;
    applicantIdLabel: string;
    billingIDLinkLabel: string;
    applicantLinkLabel: string;
    dobLabel: string;
    zipCodeLabel: string;
    checkboxLabel: string;
    continueButtonLabel: string;
    serverDate: string;
  };
  inlineError: {
    invalidApplicantId: string;
    invalidBillingID: string;
    invalidZip: string;
    invalidDate: string;
  };
  placeholder: {
    dateOfBirthPlaceholder: string;
  };
  alert: {
    accountNotFound: string;
  };
}

export interface IPayNowConfirmationBinderPaymentDetailsAEMContent
  extends IAEMContentResponseStatus {
  label: {
    sectionTitle: string;
    almostDoneTitle: string;
    almostDoneDescription: string;
    continueButtonText: string;
    paymentCompletedTitle: string;
    paymentSubtitle: string;
    printText: string;
    printTooltipText: string;
    paidText: string;
    paymentDateLabel: string;
    paymentMethodLabel: string;
    nextPaymentDateLabel: string;
    nextPaymentDateDescription: string;
    questionsConcerns: string;
    questionsConcernsAnswer: string;
    autopayLabel: string;
    autopayHeading: string;
    autopayOff: string;
    autopayOn: string;
    autoPaymentMethodLabel: string;
    confirmationNumberLabel: string;
  };
  alert: {
    autopayFail: string;
  };
}

export interface IPayLaterConfirmationBinderPaymentDetailsAEMContent
  extends IAEMContentResponseStatus {
  label: {
    sectionTitle: string;
    returnButtonText: string;
    paymentCompletedTitle: string;
    paymentSubtitle: string;
    printText: string;
    printTooltipText: string;
    paidText: string;
    paymentDateLabel: string;
    paymentMethodLabel: string;
    nextPaymentDateLabel: string;
    nextPaymentDateDescription: string;
    questionsConcerns: string;
    questionsConcernsAnswer: string;
    autopayLabel: string;
    autopayHeading: string;
    autopayOff: string;
    autopayOn: string;
    autoPaymentMethodLabel: string;
    confirmationNumberLabel: string;
    titleApplicationTracker: string;
    bodyApplicationTracker: string;
  };
  alert: {
    autopayFail: string;
  };
}

export interface IPayLaterCancelConfirmationBinderPaymentDetailsAEMContent
  extends IAEMContentResponseStatus {
  label: {
    sectionTitle: string;
    returnButtonText: string;
    paymentCancelTitle: string;
    paymentCancelDescription: string;
    printText: string;
    printTooltipText: string;
    paidText: string;
    paymentDateLabel: string;
    paymentMethodLabel: string;
    questionsConcerns: string;
    questionsConcernsAnswer: string;
    confirmationNumberLabel: string;
  };
  alert: { firstPaymentAlert: string };
}

export interface IPayLaterUpdateConfirmationBinderPaymentDetailsAEMContent
  extends IAEMContentResponseStatus {
  label: {
    sectionTitle: string;
    returnButtonText: string;
    paymentUpdateTitle: string;
    paymentUpdateDescription: string;
    printText: string;
    printTooltipText: string;
    paidText: string;
    paymentDateLabel: string;
    paymentMethodLabel: string;
    questionsConcerns: string;
    questionsConcernsAnswer: string;
    confirmationNumberLabel: string;
  };
}

export interface IPayLaterScheduleConfirmationBinderPaymentDetailsAEMContent
  extends IAEMContentResponseStatus {
  label: {
    sectionTitle: string;
    returnButtonText: string;
    paymentScheduleTitle: string;
    paymentScheduleDescription: string;
    printText: string;
    printTooltipText: string;
    paidText: string;
    paymentDateLabel: string;
    paymentMethodLabel: string;
    nextPaymentDateLabel: string;
    nextPaymentDateDescription: string;
    questionsConcerns: string;
    questionsConcernsAnswer: string;
    autopayLabel: string;
    autopayHeading: string;
    autopayOff: string;
    autopayOn: string;
    autoPaymentMethodLabel: string;
    confirmationNumberLabel: string;
  };
  alert: {
    autopayScheduleFail: string;
  };
}
export interface IBinderAllPaymentsPageAEMContent
  extends IAEMContentResponseStatus {
  label: {
    sectionHeader: string;
    allPaymentTitle: string;
    paymentDueDate: string;
    expiringPolicy: string;
    automaticPaymentsLabel: string;
    onLabel: string;
    offLabel: string;
    coverageUntil?: string;
  };
  inlineError: {
    latePayment: string;
    paymentAlertWarning: string;
    scheduledPaymentIndicator: string;
  };
  alert: { selectOnePayment: string };
}

export interface IBinderPaymentsPageAEMContent
  extends IAEMContentResponseStatus {
  label: {
    sectionHeader: string;
    currentBalance: string;
    minimumDue: string;
    latePaymentTitle: string;
    upcomingPaymentTitle: string;
    noUpcomingPaymentLabel: string;
    makePaymentButton: string;
    paymentDueDate: string;
    scheduledPaymentHeader: string;
    paymentScheduledLabel: string;
    automaticPaymentsLabel: string;
    onLabel: string;
    offLabel: string;
    editLink: string;
  };
  inlineError: {
    paymentOverdue: string;
  };
  alert: { latePaymentAlert: string; paymentProcessing: string };
}
export interface ISessionTimeoutCommonAEMContents
  extends IAEMContentResponseStatus {
  label: {
    exitLink: string;
    heading: string;
    body: string;
    mobileSessionTimeoutDialogHeading: string;
    mobileSessionTimeoutDialogBody: string;
    mobileSessionTimeoutDialogContinueButton: string;
    continueButton: string;
    logout: string;
  };
  alert: {
    sessionTimeOutMessage: string;
    mobileExpiredSessionTimeOutDialogHeading: string;
    mobileExpiredSessionTimeOutDialogBody: string;
  };
}

export interface IAccessTokenExpiredModalAEMContent
  extends IAEMContentResponseStatus {
  label: {
    continueButtonToBAM: string;
    expiredHeading: string;
    expiredBody: string;
  };
}

export interface IAccessTokenExpiringModalAEMContent
  extends IAEMContentResponseStatus {
  label: {
    continueButton: string;
    expiringBody: string;
    expiringHeading: string;
  };
}

export interface IBrowserIncompatibilityErrorAEMContents
  extends IAEMContentResponseStatus {
  label: {
    browserSupportPrimaryText: string;
    browserSupportSecondaryText: string;
    chromeLink: string;
    fireFoxLink: string;
    safariLink: string;
    ielink: string;
    edgeLink: string;
    operaLink: string;
  };
  image: {
    browserNotSupportedImage: {
      altText: string;
      imgUrl: string;
    };
  };
}

export interface ILoaderMessage extends IAEMContentResponseStatus {
  label: {
    doNotExitLabel: string;
    loadingLabel: string;
  };
}

export interface IOneTimePaymentErrors {
  showAlert: boolean;
  alertType:
    | ALERT_TYPES.DANGER
    | ALERT_TYPES.INFORMATION
    | ALERT_TYPES.SUCCESS
    | ALERT_TYPES.WARNING
    | undefined;
  alertMessage: string;
  alertCaMessage: string;
  showBillingVelocityReachedError: boolean;
  showUnabletoProcessError: boolean;
  showEmailAddressNotPresentError: boolean;
  showEmailAddressFailedValidationError: boolean;
  keepHtmL?: boolean;
}

export interface IScheduledEmailErrors
  extends Omit<
    IOneTimePaymentErrors,
    | 'showBillingVelocityReachedError'
    | 'showUnabletoProcessError'
    | 'showEmailAddressNotPresentError'
    | 'showEmailAddressFailedValidationError'
  > {
  error: boolean;
}

export interface IPaymentFailedAEMContents extends IAEMContentResponseStatus {
  label: {
    heading: string;
    unableToProcessPaymentMessage: string;
    billingAccountVelocityReached: string;
    exitButton: string;
    returnButton: string;
    logout: string;
    emailAddressNotPresentHeading: string;
    emailAddressFailedValidationMessage: string;
    emailAddressNotPresentMessage: string;
    dependentCATitle: string;
    dependentCABody: string;
    termedCATitle: string;
    termedCABody: string;
    termedCAGovtBody: string;
    titlePaymentIssue: string;
    bodyPaymentIssue: string;
    closeButtonPaymentIssue: string;
    returnButtonPaymentIssue: string;
    caTitlePaymentIssue: string;
    caBodyPaymentIssue: string;
    caCloseButtonPaymentIssue: string;
    caReturnButtonPaymentIssue: string;
  };
}

export interface ITechnicalDifficulty extends IAEMContentResponseStatus {
  label: {
    heading: string;
    message: string;
    exitButton: string;
    logout: string;
    genericErrorMessage: string;
    returnToPayments: string;
    sectionHeader: string;
    autoBillPayActivationMessage: string;
    autoBillPayActivationHeader: string;
  };
}

export interface IGlobalTechnicalDifficulty {
  errorCode: string;
  isBrokerUserWithAutoPayError?: boolean;
}

export interface IErrorResponse {
  errorCode: string;
  statusCode: string;
  errorMessage: string;
}
export interface IMyWalletDetailsAEMContent extends IAEMContentResponseStatus {
  alert: {
    caEmailInvalidFormatErrorMessage: string;
    caEmailLengthValidationErrorMessage: string;
    memberEmailInvalidFormatErrorMessageIL: string;
    memberEmailLengthValidationErrorMessageIL: string;
    memberEmailInvalidFormatErrorMessageTX: string;
    memberEmailLengthValidationErrorMessageTX: string;
    memberEmailInvalidFormatErrorMessageNM: string;
    memberEmailLengthValidationErrorMessageNM: string;
    memberEmailInvalidFormatErrorMessageOK: string;
    memberEmailLengthValidationErrorMessageOK: string;
    memberEmailInvalidFormatErrorMessageMT: string;
    memberEmailLengthValidationErrorMessageMT: string;
    govEmailInvalidFormatErrorMessageIL: string;
    govEmailLengthValidationErrorMessageIL: string;
    govEmailInvalidFormatErrorMessageTX: string;
    govEmailLengthValidationErrorMessageTX: string;
    govEmailInvalidFormatErrorMessageNM: string;
    govEmailLengthValidationErrorMessageNM: string;
    govEmailInvalidFormatErrorMessageOK: string;
    govEmailLengthValidationErrorMessageOK: string;
    govEmailInvalidFormatErrorMessageMT: string;
    govEmailLengthValidationErrorMessageMT: string;
    attentionCaTitle: string;
    errorInvalidEmailFormatMobile: string;
    errorMaximumEmailLengthMobile: string;
  };
  label: {
    sectionHeader: string;
    paymentMethodsTitle: string;
    addPaymentMethodTitle: string;
    defaultPaymentMethodText: string;
    bankAccountLabel: string;
    paymentCardLabel: string;
    deleteModalCancelButton: string;
    deleteModalDeleteButton: string;
    deleteModalDescription: string;
    deleteModalTitle: string;
    cannotDeleteModalDescription: string;
    cannotDeleteModalOkayButton: string;
    cannotDeleteModalTitle: string;
    automaticPaymentsLabel: string;
    onLabel: string;
    manageLink: string;
    offLabel: string;
    newVersionButton: string;
    newVersionMessage: string;
    nextAutopayBillPayment: string;
    myWalletToastMessageForFreeze: string;
    myWalletToastMessageForLockdown: string;
    myWalletToastMessageForNonAutoPay: string;
    mapdOrPdpUnableToProcess?: string;
    govtCannotDeleteModalDescription: string;
    paymentMethodsForLabel: string;
    returnToPaymentLink: string;
    myWalletMapdTitle: string;
    myWalletPdpTitle: string;
    myWalletMedsupTitle: string;
  };
}

export interface IAddNewPaymentMethodWalletBank
  extends IAEMContentResponseStatus {
  alert: {
    invalidDataEntry: string;
    paymentAccountBlocked: string;
  };
  inlineError: {
    invalidNickname: string;
  };
  label: {
    addBankTitle: string;
    paymentNicknameLabel: string;
    nicknameOptionalMessageLabel: string;
    defaultMethodCheckboxLabel: string;
    saveChangesButtonLabel: string;
    cancelLinkLabel: string;
    cancelModalPositiveButton: string;
    cancelModalNegativeButton: string;
    cancelModalTitle: string;
    cancelModalDescription: string;
    membersEmailLabel: string;
    membersEmailMessage: string;
    emailNotFoundCommunicationMessage: string;
    emailNotAccessibleCommunicationMessage: string;
  };
}

export interface IAddNewPaymentMethodWalletCard
  extends IAEMContentResponseStatus {
  alert: {
    cardNotSupported: string;
    paymentAccountBlocked: string;
  };
  inlineError: {
    invalidNickname: string;
  };
  label: {
    paymentCardTitleLabel: string;
    paymentNicknameLabel: string;
    nicknameOptionalMessageLabel: string;
    defaultMethodCheckboxLabel: string;
    saveChangesButtonLabel: string;
    cancelLinkLabel: string;
    cancelModalPositiveButton: string;
    cancelModalNegativeButton: string;
    cancelModalTitle: string;
    cancelModalDescription: string;
    membersEmailLabel: string;
    membersEmailMessage: string;
    emailNotFoundCommunicationMessage: string;
    emailNotAccessibleCommunicationMessage: string;
  };
}

export interface INavigationPageAEMContent extends IAEMContentResponseStatus {
  label: {
    walletHeader: string;
    paymentHeader: string;
    paymentHistory: string;
    billingHistory: string;
    paymentAndBilling: string;
    continueToNewVersion: string;
    goToOldVersion: string;
  };
}

export interface IUpdateWalletBank extends IAEMContentResponseStatus {
  inlineError: {
    invalidNickname: string;
  };
  label: {
    sectionHeader: string;
    bankAccountTitle: string;
    deleteButtonLabel: string;
    paymentNicknameLabel: string;
    accountTypeLabel: string;
    checkingAccount: string;
    savingsAccount: string;
    personalOrBusinessLabel: string;
    personal: string;
    business: string;
    checkboxLabel: string;
    optionalLabel: string;
    cancelModalPositiveButton: string;
    cancelModalNegativeButton: string;
    cancelModalTitle: string;
    cancelModalDescription: string;
    cannotDeleteModalDescription: string;
    cannotDeleteModalOkayButton: string;
    cannotDeleteModalTitle: string;
    saveButtonText: string;
    cancelButtonText: string;
    saveModalCancelButton: string;
    saveModalDescription: string;
    saveModalSaveButton: string;
    saveModalTitle: string;
    deleteModalCancelButton: string;
    deleteModalDeleteButton: string;
    deleteModalDescription: string;
    deleteModalTitle: string;
    govtCannotDeleteModalDescription: string;
  };
}

export interface IUpdateWalletCard extends IAEMContentResponseStatus {
  inlineError: {
    invalidNickname: string;
    invalidExpDate: string;
    invalidPaymentZIP: string;
  };
  label: {
    sectionHeader: string;
    paymentCardTitle: string;
    deleteLabel: string;
    paymentNicknameLabel: string;
    nicknameOptionalMessageLabel: string;
    defaultMethodCheckboxLabel: string;
    expirationDateLabel: string;
    monthPlaceholder: string;
    yearPlaceholder: string;
    zipCode: string;
    saveChangesButtonLabel: string;
    cancelText: string;
    cancelModalPositiveButton: string;
    cancelModalNegativeButton: string;
    cancelModalTitle: string;
    cancelModalDescription: string;
    cannotDeleteModalDescription: string;
    cannotDeleteModalOkayButton: string;
    cannotDeleteModalTitle: string;
    saveModalCancelButton: string;
    saveModalDescription: string;
    saveModalSaveButton: string;
    saveModalTitle: string;
    deleteModalCancelButton: string;
    deleteModalDeleteButton: string;
    deleteModalDescription: string;
    deleteModalTitle: string;
    serverDate: string;
  };
}

export interface IViewScheduledPayments extends IAEMContentResponseStatus {
  label: {
    pageHeading: string;
    pageSubHeading: string;
    confirmationNumber: string;
    amountLabel: string;
    paymentDate: string;
    paymentMethod: string;
    pageTitle: string;
    print: string;
    printTooltip: string;
    editButton: string;
    cancelButton: string;
    paymentCutoffMessage: string;
    qncLabel: string;
    qncMessage: string;
    cancelModalTitle: string;
    cancelModalDescription: string;
    cancelModalYesButton: string;
    cancelModalNoButton: string;
    serverDate: string;
    memberId?: string;
    backButton?: string;
  };
}

export interface IViewPaymentDeatils extends IAEMContentResponseStatus {
  label: {
    pageHeading: string;
    backButton: string;
    confirmationNumber: string;
    amountLabel: string;
    paymentDate: string;
    paymentMethod: string;
    editButton: string;
    cancelButton: string;
    paymentCutoffMessage: string;
    qncLabel: string;
    qncMessage: string;
    cancelModalTitle: string;
    cancelModalDescription: string;
    cancelModalYesButton: string;
    cancelModalNoButton: string;
    scheduledLabel: string;
    accountChargedLabel: string;
    appliedToBillLabel: string;
    declinedLabel: string;
    cancelledLabel: string;
    returnedLabel: string;
    serverDate: string;
    scheduledAutopayMessage: string;
  };
}

export interface IPaymentDetailsResponse {
  cim?: string | null;
  billPeriod?: string | null;
  minimumAmountDue?: number;
  billDraftMethod?: string;
  amountDue?: number;
  dueDate?: string;
  dueDays?: number;
  upcomingPaymentIndicator?: boolean;
  paymentPendingIndicator?: boolean;
  premiumDetailsList?: IPremiumDetails[];
  exchangeIndicator?: string; // TODO: Make this mandatory field later
  latePaymentIndicator?: boolean;
  caseNumber?: string;
  billNames?: string;
  billedPremium?: number;
  hasScheduledPayments?: boolean;
  minimumRequiredPremium?: number | 0; //used for binder pay later
  remainingBinderAmount?: number | 0; //used for binder pay later autopay
  claimsPaidThruDate?: string | null;
  autoPayDraftDate?: string;
  subcriberId?: string;
  mppId?: number;
}
export interface IPaymentBillResponse {
  errorMessage?: null | string;
  response?: IBillDetails;
}

export interface IPaymentDetails extends IPaymentDetailsResponse {
  paymentType?: string; // selected payment option  from payment amount i.e currentBalance,minimumDue,otherAmount
  paymentAmount?: number; // selected payment amount
  paymentDate?: string;
  premiumDetailsList?: IPremiumDetails[];
  hasMultipleBills?: boolean;
  selectedBillCimNumber?: string;
  selectedBillMppId?: number | null; // used for the Active govt flow
  selectedCaseNumber?: string;
  exchangeIndicator?: string;
  selectedBillExchangeIndicator?: string; // for individual bill
  memberExchangeIndicator?: {
    exchangeIndicator: string | undefined;
    cim: string | null | undefined;
    caseNumber: string | undefined;
  }; // according to calculated global logic
  paymentMethod?: string; // selected payment method
  fiservResponse?: IFiservResponse;
  paymentDesc?: string; // to use in review payment and payment confirmation
  cim?: string | null;
  billPeriod?: string | null;
  amountDue?: number;
  dueDate?: string;
  dueDays?: number;
  upcomingPaymentIndicator?: boolean;
  minimumAmountDue?: number;
  memberPaymentMethod?: string;
  selectedPaymentMethodType?: string;
  fundingAccountToken?: string;
  addToWallet?: boolean;
  fundingCategory?: string; // funding Category Credit / Debit / Check
  email?: string | null | undefined;
}

export interface IHoursOfOperation extends IAEMContentResponseStatus {
  label: {
    pdpHoursOfOperation?: string;
    mapdHoursOfOperation?: string;
    vmsMedsuppHoursOfOperation?: string;
    tmgMedsuppHoursOfOperation?: string;
  };
}

export interface IFiservResponse {
  fundingAccountValidationResult: {
    summaryValidationState?: string;
    checkValidationDetail?: {
      fundingAccountType: string;
    };
    cardValidationDetail?: {
      fundingMethodDetail: {
        fundingCategory: string;
        fundingMethod: string;
        fundingCardType: string;
      };
      expirationDateState?: string;
      securityCodeValidationState?: string;
      zipCodeValidationState?: string;
      isBlocked?: boolean;
      isAccountValid?: boolean;
    };
    fundingAccount?: {
      fundingAccountLastFourDigit?: string;
      fundingAccountToken?: string;
      fundingCategory?: string;
      fundingMethod?: string;
      bankAccountType?: string;
      type?: string;
    };
  };
  result?: {
    statusCode: string;
    statusMessages: [
      {
        code: number;
        type: string;
        description: string;
      },
    ];
  };
}

export interface IAutopayIframeFiservResponse {
  result: {
    statusCode: string;
    statusMessages: [
      {
        code: number;
        type: string;
        description: string;
      },
    ];
  };
  fundingAccountValidationResult: {
    summaryValidationState: string;
    checkValidationDetail: {
      routingNumberState: string;
      checkAccountValidationState: string;
      fundingAccountType: string;
      isBlocked: boolean;
      isAccountValid: boolean;
    };
    fundingAccount: {
      fundingAccountToken: string;
      fundingAccountLastFourDigit: string;
      fundingMethod: string;
      fundingCategory: string;
      firstName: string;
      lastName: string;
      bankAccountType: string;
    };
  };
}

export interface IBillDetails {
  billDetails: IPaymentDetailsResponse[];
  noBillFound?: boolean;
}

export interface IBinderBill extends IPaymentDetailsResponse {
  exchangeIndicator?: string | '';
  applicationId?: string;
  mppId?: number;
}

export interface IBinderBillDetails {
  binderBills?: IBinderBill[];
  hasMultipleBills?: boolean;
}

export interface IBillsList {
  hasMultipleBills?: boolean;
  bills?: IPaymentDetailsResponse[];
  noBillIndicator?: boolean;
  hasMultipleBillsWithValue?: boolean; // Added to identify multiple bills which are having bill period with value instead of null
  displayAutopayDraftDate?: string; // used for next autopay bill payment
  noBillFound?: boolean;
  billsLoaded?: boolean; // added to call session token api once during switching of plans
}

export interface IBillsInfo {
  noBillIndicator: boolean;
  redirectToAllPayments: boolean;
  billInfoCim: string;
  billInfoCaseNumber: string;
  billInfoExchangeIndicator: string;
}

export interface IBillResponseAndSessionData {
  billsResponse: IBillDetails;
  sessionData?: ISESSION_DATA;
  billsInfo?: IBillsInfo;
  allProductDetails?: IGovernmentProductDetails[];
  memberBillingInfoRequestPayload?: IMemberBillingInfoRequest;
}

export interface IOnSuccessPaymentBills {
  bills: IBillDetails;
  noBillFound?: boolean;
  govtActiveUserTypeCode?: number;
}

export interface IPremiumDetails {
  productName: string;
  billedPremium: number;
}

export interface ITokenDetails {
  token?: string | null;
  session?: string | null;
  messageId?: string | null;
  timeStamp?: string | null;
  sessionValidFlag?: boolean;
  sessionExpired?: boolean;
}

export interface IImmediatePaymentDetails {
  confirmationCode?: string;
  paymentIndicator?: boolean;
  paymentAuthorizationStatus?: string;
  fundingMethod?: string;
  paymentDateTimeStamp?: string;
  paymentAmountValidationState?: string;
  reportDate?: string;
  paymentEventID?: string;
  mppId?: number;
  amountProcessed?: string;
  caseNumber?: string;
  transactionType?: string;
  result?: {
    statusCode?: string;
    statusMessages?: {
      type?: string;
      description?: string;
      code?: string;
    }[];
  };
  errorCode?: string;
  errorMessage?: string;
  statusCode?: string;
}

export interface IScheduledMaintenanceDetails {
  message: string;
  active: boolean;
  endDateTime: string;
  isLoaded: boolean;
  title?: string;
}

export interface IMemberDetails {
  memberId?: string | null;
  mppId?: number | null;
  userType?: USER_TYPES | null;
  accessTokenValid?: boolean;
  memberBillingInfoRequestPayload?: IMemberBillingInfoRequest;
  caId?: string | null;
  showForcedConversionModal?: boolean;
  conversionTypeDetails?: IConversionTypeDetails;
  policyId?: string;
  retailOrGovMemberResponse?: IValidateActiveMemberResponse;
  brokerDetails?: IBrokerDetails;
  // HealthSpring specific - cached from validateActiveMember response
  healthspringProducts?: string[]; // ['MAPD', 'PDP', 'MEDSUP']
  healthspringRoutingDecision?: 'noPayments' | 'pickYourPlan' | 'mapd' | 'pdp' | 'medsup';
  healthspringBAMFiltered?: boolean;
  selectedProductExternalPolicyId?: string; // Currently selected product's externalPolicyId for Payment History API
}

export interface IConversionTypeDetails {
  conversionType?: MEMBER_CONVERSION_TYPES;
  lockdownPeriod: boolean;
  freezePeriod: boolean;
  forcedConvNonAutopay?: boolean;
  showAPForcedConverted: boolean; // here AP is Autopay
}

export interface ILoaderDetails {
  isVisible: boolean;
  message?: string | null;
}

export interface IMenuItemsConfiguration {
  paymentHistoryPage: boolean;
  billingHistoryPage: boolean;
  myWalletsPage: boolean;
  recentPaymentsSection: boolean;
  autoBillPaySection: boolean;
  autoBillPayManageLink: boolean;
  isLoaded: boolean;
  schedulePaymentPage: boolean;
}

export interface IEmailConfirmationStatus {
  mailSent: boolean | undefined;
  message: string | undefined;
  isLoaded?: boolean;
}

export interface IFundingAcountDetailsForBroker {
  lastFourDigits: string;
  fname: string;
}

export interface IAPIStatus {
  [API_STATUS_TYPES.LOADER_SCREEN_COUNTER]: number;
  [API_STATUS_TYPES.SHOW_ERROR_SCREEN]: boolean;
}

export interface IUserDetails {
  userName?: string;
  emailId?: string;
  origin?: ORIGIN_TYPES | null;
}

export interface IBinderPayNowLoginDetails {
  applicationId: string;
  dateOfBirth?: string | undefined;
  exchangeIndicator: string;
  memberStateCode: string;
  memberZipCode?: number | undefined;
  paymentAmount: number;
  sourceSystem: string;
  email?: string | undefined;
  monthlyBill?: number | undefined;
  redirectURI: string;
  mppId?: number;
  effectiveDate?: string;
  binderPaymentStatus?: BINDER_PAYMENT_STATUS;
}

export interface IBinderSchedulePayment {
  errorMessage: string | null;
  response?: {
    referenceId: string;
    referenceCode: string;
    paymentAmountValidationState?: string;
    billingAccountValidity?: Record<string, unknown>;
    fundingAccountTokenValidationResult?: Record<string, unknown>;
    paymentAmount: number;
    caseNumber?: string;
    mppId?: number;
    addedToWallet?: boolean;
    result?: Record<string, unknown>;
    isAddedToWallet?: boolean;
  };
}

export interface IBinderImmediatePayment {
  errorMessage: string | null;
  response: {
    memberId?: string;
    confirmationCode: string;
    paymentAuthorizationStatus?: string;
    fundingMethod: string;
    paymentDateTimeStamp?: string;
    paymentAmountValidationState?: string;
    reportDate?: string;
    paymentEventID?: string;
    paymentIndicator?: boolean;
    mppId?: number;
    amountProcessed: string;
    caseNumber?: string;
    transactionType?: string;
    result?: Record<string, unknown>;
  };
}
export interface IHPSRedirectionParams {
  memberProfileId: string;
  username: string;
  id: number;
  dob: string;
  zipCode: string;
  uid: string;
  carrierCode: string;
  pmiInd: number;
}

export interface IActiveUserEmailResponse {
  email?: string | null | undefined;
}

export interface IPickYourPlan extends IAEMContentResponseStatus {
  label: {
    title: string;
    heading: string;
    subHeading: string;
    ifmLink: string;
    medicareLink: string;
    qncLabel: string;
    qncMessage: string;
  };
}

export interface IMultipleProductsLandingPage extends IAEMContentResponseStatus {
  label: {
    title: string;
    intro: string;
    medicareSupplementLabel: string;
    medicareAdvantageLabel: string;
    medicarePartDLabel: string;
  };
}

export interface ITermsOfUse extends IAEMContentResponseStatus {
  label: {
    termsOfUseTitle: string;
    termsOfUseContent: string;
    accept: string;
    continueButton: string;
    termsOfUseCheckbox: string;
  };
}

export interface INoAccess extends IAEMContentResponseStatus {
  label: {
    noAccessTitle: string;
    noAccessHeading: string;
    noAccessContent: string;
  };
}

export interface ISessionTimeOut extends IAEMContentResponseStatus {
  label: {
    sessionTimeOutTitle: string;
    sessionTimeOutHeading: string;
    sessionTimeOutContent: string;
  };
}

export interface ILoggedOut extends IAEMContentResponseStatus {
  label: {
    title: string;
    loggedOutMsg: string;
    closeTab: string;
  };
}

export interface IAutoPayPremiumPaymentAEMContent extends IAEMContentResponseStatus {
  label: {
    pageHeading: string;
    subscriberLabel: string;
    contractNumberLabel: string;
    paymentScheduleTitle?: string;
    autopayPremiumPayments: string;
    unknownValue: string;
    autoBillPay: string;
    manageButtonLabel: string;
    withdrawalFrequencyLabel?: string;
    withdrawalDayLabel?: string;
    currentPaidToDateLabel?: string;
    lastPaymentMadeOnLabel?: string;
    nextScheduledPaymentLabel?: string;
    autoBillPayLabel?: string;
    autoBillPayDisclaimer?: string;
    enrollmentSuccessMessage: string;
  };
}

export interface IAutomaticPaymentsSetupAEMContent extends IAEMContentResponseStatus {
  label: {
    addPaymentTitle: string;
    addPaymentIntro: string;
    commSettingsTitle: string;
    whichPoliciesText: string;
    emailDisclaimer: string;
    disclaimer: string;
    labelFirst: string;
    labelLast: string;
    labelAcctType: string;
    labelAcctNumber: string;
    labelRouting: string;
    labelMonthlyWithdrawal: string;
    labelWithdrawDescription: string;
    labelPayFreq: string;
    labelEmail: string;
    labelAssigneeFirst: string;
    labelAssigneeLast: string;
    valueChecking: string;
    valueSavings: string;
    valueCorporate: string;
    valueMonthly: string;
    valueQuarterly: string;
    valueSemiannual: string;
    valueAnnual: string;
    checkboxConfirm: string;
    checkboxAgree: string;
    checkboxFlexDvh: string;
    checkboxHeartStroke: string;
    ctaConfirmAbp: string;
    ctaCancelAbp: string;
  };
}

export interface IMapdPaymentsAEMContent extends IAEMContentResponseStatus {
  label: {
    mapdPremiumPaymentsHeading: string;
    mapdPremiumPaymentsIntro: string;
    mapdPremiumPaymentsPayPremiumBillLabel: string;
    mapdPremiumPaymentsNextBillAmountDueDateLabel: string;
    mapdPremiumPaymentsPaymentHistoryLabel: string;
    mapdPremiumPaymentsFooterNote: string;
    mapdOneTimeOnlinePaymentLabel: string;
    mapdOneTimeOnlinePaymentUrl: string;
  };
}

export interface IHsGlobalErrorAEMContent extends IAEMContentResponseStatus {
  label: {
    noPoliciesHeading: string;
    noPoliciesDescription: string;
  };
}

export interface IAEMScreenContent {
  [PAGE_NAME.HPS_MANAGED_ERROR]: IHPSErrorScreen;
  [PAGE_NAME.MEMBER_VALIDATION]: IMemberValidationAEMContents;
  [PAGE_NAME.PAYMENT_TERMS]: IPaymentTermsAEMContents;
  [PAGE_NAME.ALL_PAYMENT_DETAILS]: IAllPaymentDetailsAEMContent;
  [PAGE_NAME.ALL_PAYMENT_DETAILS_ACTIVE]: IAllPaymentDetailsAEMContent;
  [PAGE_NAME.PAYMENT_COMPLETED]: IPaymentCompleteAEMContents;
  [PAGE_NAME.CANCELLED_PAYMENT_CONFIRMATION]: ICancelledPaymentConfirmationAEMContents;
  [PAGE_NAME.CANCELLED_CONFIRMATION_INTERSTITIAL]: ICancelledConfirmationInterstitialAEMContents;
  [PAGE_NAME.UPDATE_PAYMENT_COMPLETED]: IPaymentCompleteAEMContents;
  [PAGE_NAME.PAYMENT_DETAILS]: IPaymentDetailsAEMContent;
  [PAGE_NAME.PREMIUM_PAYMENTS]: IPaymentDetailsAEMContent;
  [PAGE_NAME.PAYMENT_DETAILS_ACTIVE_MEMBER]: IPaymentDetailsAEMContent;
  [PAGE_NAME.MAKE_PAYMENT]: IMakePaymentAEMContents;
  [PAGE_NAME.MAKE_PAYMENT_ACTIVE_MEMBER]: IMakePaymentAEMContents;
  [PAGE_NAME.REVIEW_PAYMENT_DETAILS]: IReviewPaymentDetailsAEMContent;
  [PAGE_NAME.BROWSER_INCOMPATIBLE_ERROR]: IBrowserIncompatibilityErrorAEMContents;
  [PAGE_NAME.UNABLE_TO_PROCESS_PAYMENT]: IPaymentFailedAEMContents;
  [PAGE_NAME.TECHNICAL_DIFFICULTY]: ITechnicalDifficulty;
  [PAGE_NAME.REVIEW_PAYMENT_DETAILS_ACTIVE_MEMBER]: IReviewPaymentDetailsAEMContent;
  [PAGE_NAME.MY_WALLET]: IMyWalletDetailsAEMContent;
  [PAGE_NAME.ADD_NEW_PAYMENT_METHOD_WALLET_BANK]: IAddNewPaymentMethodWalletBank;
  [PAGE_NAME.ADD_NEW_PAYMENT_METHOD_WALLET_CARD]: IAddNewPaymentMethodWalletCard;
  [PAGE_NAME.UPDATE_WALLET_BANK]: IUpdateWalletBank;
  [PAGE_NAME.UPDATE_WALLET_CARD]: IUpdateWalletCard;
  [PAGE_NAME.VIEW_SCHEDULED_PAYMENTS]: IViewScheduledPayments;
  [PAGE_NAME.BINDER_VIEW_SCHEDULED_PAYMENTS]: IViewScheduledPayments;
  [PAGE_NAME.TECHNICAL_DIFFICULTY]: ITechnicalDifficulty;
  [PAGE_NAME.SCHEDULED_PAYMENT_CONFIRMATION]: IScheduledPaymentConfirmationAEMContents;
  [PAGE_NAME.AUTO_PAYMENT_SETTINGS]: IAutoPaymentSettingsAEMContents;
  [PAGE_NAME.AUTO_PAYMENT_SUCCESS]: IAutoPaymentSuccessAEMContents;
  [PAGE_NAME.PAYMENT_HISTORY]: IPaymentHistoryAEMContent;
  [PAGE_NAME.BILLING_HISTORY_LIST]: IBillingHistoryAEMContent;
  [PAGE_NAME.BILLING_HISTORY_SPREADSHEET]: IBillingHistorySpreadsheetAEMContent;
  [PAGE_NAME.BINDER_MAKE_PAYMENT]: IBinderMakePayment;
  [PAGE_NAME.BINDER_PAY_LATER_MAKE_PAYMENT]: IBinderPayLaterMakePayment;
  [PAGE_NAME.REVIEW_BINDER_PAYMENT_DETAILS]: IReviewBinderPaymentDetailsAEMContent;
  [PAGE_NAME.APPLICANT_BINDER_PAYMENT_DETAILS]: IApplicantBinderPaymentDetailsAEMContent;
  [PAGE_NAME.BINDER_PAY_NOW_CONFIRMATION_PAYMENT_DETAILS]: IPayNowConfirmationBinderPaymentDetailsAEMContent;
  [PAGE_NAME.BINDER_PAY_LATER_CONFIRMATION_PAYMENT_DETAILS]: IPayLaterConfirmationBinderPaymentDetailsAEMContent;
  [PAGE_NAME.BINDER_PAY_LATER_CANCEL_CONFIRMATION_PAYMENT_DETAILS]: IPayLaterCancelConfirmationBinderPaymentDetailsAEMContent;
  [PAGE_NAME.BINDER_PAY_LATER_UPDATE_CONFIRMATION_PAYMENT_DETAILS]: IPayLaterUpdateConfirmationBinderPaymentDetailsAEMContent;
  [PAGE_NAME.BINDER_PAY_LATER_SCHEDULE_CONFIRMATION_PAYMENT_DETAILS]: IPayLaterScheduleConfirmationBinderPaymentDetailsAEMContent;
  [PAGE_NAME.BINDER_ALL_PAYMENTS_PAGE]: IBinderAllPaymentsPageAEMContent;
  [PAGE_NAME.BINDER_PAYMENTS_PAGE]: IBinderPaymentsPageAEMContent;
  [PAGE_NAME.VIEW_PAYMENT_TRACKER_DETAILS_SCREEN]: IViewPaymentDeatils;
  [PAGE_NAME.PICK_YOUR_PLAN_VIEW]: IPickYourPlan;
  [PAGE_NAME.SELECT_PLAN]: IMultipleProductsLandingPage;
  [PAGE_NAME.TERMS_OF_USE]: ITermsOfUse;
  [PAGE_NAME.MEDICARE_LANDING]: IPaymentDetailsAEMContent;
  [PAGE_NAME.HS_PAYMENT_HISTORY]: IHealthspringPaymentHistoryAEMContent;
  [PAGE_NAME.NO_ACCESS]: INoAccess;
  [PAGE_NAME.SESSION_TIMEOUT]: ISessionTimeOut;
  [PAGE_NAME.LOGGED_OUT]: ILoggedOut;
  [PAGE_NAME.AUTO_PAY_PREMIUM_PAYMENT]: IAutoPayPremiumPaymentAEMContent;
  [PAGE_NAME.AUTOMATIC_PAYMENTS_SETUP]: IAutomaticPaymentsSetupAEMContent;
  [PAGE_NAME.MAPD_PAYMENTS]: IMapdPaymentsAEMContent;
  [PAGE_NAME.HS_GLOBAL_ERROR]: IHsGlobalErrorAEMContent;
}

export interface IAEMCommonContent {
  [COMMON_COMPONENTS.CANCEL_MODAL_CONTENT]: ICancelCommonAEMContents;
  [COMMON_COMPONENTS.CONVERSION_MODAL]: ICancelCommonAEMContents;
  [COMMON_COMPONENTS.HEADER]: IHeaderCommonAEMContents;
  [COMMON_COMPONENTS.CANCEL]: ICancelCommonAEMContents;
  [COMMON_COMPONENTS.FOOTER]: IFooterCommonAEMContents;
  [COMMON_COMPONENTS.ACTIVE_MEMBER_FOOTER]: IFooterCommonAEMContents;
  [COMMON_COMPONENTS.GUEST_GOVERNMENT_FOOTER]: IFooterCommonAEMContents;
  [COMMON_COMPONENTS.ACTIVE_GOVERNMENT_FOOTER]: IFooterCommonAEMContents;
  [COMMON_COMPONENTS.SESSION_TIMEOUT]: ISessionTimeoutCommonAEMContents;
  [COMMON_COMPONENTS.NAVIGATION_BAR]: INavigationPageAEMContent;
  [COMMON_COMPONENTS.LOADER_MESSAGE]: ILoaderMessage;
  [COMMON_COMPONENTS.OLD_CONVERSION_MODAL]: ICancelCommonAEMContents;
  [COMMON_COMPONENTS.AUTOPAY_ENROLMENT_MODAL]: IAutopayEnrolmentAEMContents;
  [COMMON_COMPONENTS.HOURS_OF_OPERATION]: IHoursOfOperation;
  [COMMON_COMPONENTS.AUTOPAY_SETUP_MODAL_CONTENT]: ICancelCommonAEMContents;
  [COMMON_COMPONENTS.GUEST_AUTOPAY_SETUP_MODAL_CONTENT]: ICancelCommonAEMContents;
  [COMMON_COMPONENTS.BROKER_AUTOPAY_SETUP_MODAL_CONTENT]: ICancelCommonAEMContents;
  [COMMON_COMPONENTS.ECONSENT_MODAL_CONTENT]: IEconsentModal;
}

export interface IGetWalletResponse {
  response: {
    walletFundingAccounts: Array<IWalletResponse>;
  };
}
export interface IWalletResponse {
  bankAccountType: string;
  bankName: string;
  defaultFundingSourceFlag: boolean;
  displayOrder: number;
  firstName: string | null;
  fundingAccountLastFourDigit: string;
  fundingAccountToken: string;
  fundingAccountType: string;
  fundingCategory: string;
  fundingMethod: string;
  lastName: string | null;
  nickName: string;
  status: string;
}
export interface IWallet extends IWalletResponse {
  type: PAYMENT_METHOD_TYPES;
}
export interface ISelectedWallet {
  fundingAccountLastFourDigit: string;
  fundingAccountToken: string;
}

export type PAYMENT_METHOD_TYPES = 'BANK ACCOUNT' | 'CARD';

export type FUNDING_CATEGORY = 'Check' | 'Credit' | 'Debit';

export interface IWalletsData {
  wallets?: Array<IWallet>;
  selectedWallet?: ISelectedWallet;
  selectedAddWalletType?: PAYMENT_METHOD_TYPES;
}

export interface IWalletAlertDetails {
  alertMessage?: string | JSX.Element | JSX.Element[];
  alertCaMessage?: string;
  showWalletAlert?: boolean;
  alertTitle?: string;
  alertType?: ALERT_TYPES;
  hideDismissButton?: boolean;
  redirectToPath?: string; // used to check for reset alert details during unmount
  showDeleteWalletModal?: boolean;
  deleteWalletErrorType?: DELETE_WALLET_ERROR_TYPES;
}

export interface IPaymentCustomList {
  customDataName: string;
  customDataValue: string;
}

export interface IScheduledTransaction {
  addDate?: string;
  billingAccount?: string;
  billingSubAccount?: string;
  emailAddress?: string;
  feeAmount?: number;
  lastUpdatedDate?: string;
  paymentAmount?: number;
  paymentDate: string;
  referenceCode: string;
  referenceId: string;
  status?: string;
  paymentCustomList?: IPaymentCustomList[];
  fundingAccount: IFundingAccount;
  activeAutoPay?: boolean;
  cim?: string;
}

export interface IFundingAccount {
  fundingAccountLastFourDigit: string;
  fundingAccountToken: string;
  fundingCategory: string;
  nickname: string;
  bankAccountType: string;
}
export interface IOneTimeSchedulePayment {
  isLoaded: boolean;
  count: number;
  scheduledPayments?: IScheduledTransaction[];
}

export interface IScheduleOneTimePaymentDetails {
  addedToWallet?: boolean;
  billingAccountValidity?: {
    billingAccountFound?: boolean;
    billingAccountValidationResponse?: {
      accountAcceptable?: boolean;
      blockingResults?: [
        {
          checkPermitted?: boolean;
          creditPermitted?: boolean;
          debitPermitted?: boolean;
        },
      ];
      blockingSourceDetails?: [
        {
          blockingPaymentCategoryType?: string;
          blockingSourceType?: string;
        },
      ];
      hasBlockingSourceDetails?: boolean;
      tooManyAttempts?: boolean;
      tooManyPayments?: boolean;
    };
  };
  caseNumber?: string;
  description?: string;
  details?: string[];
  fundingAccountTokenValidationResult?: {
    fundingAccountToken?: {
      bankAccountType?: string;
      fundingAccountCategory?: string;
      fundingAccountLastFourDigits?: string;
      fundingAccountType?: string;
      token?: string;
    };
    tokenState?: string;
  };
  fundingMethod?: string;
  message?: string;
  messageCode?: string;
  mppId?: number;
  paymentAmount?: number;
  paymentAmountValidationState?: string;
  paymentDate?: string;
  referenceCode?: string;
  referenceId?: string;
  result?: {
    statusCode?: string;
    statusMessages?: [
      {
        code?: string;
        description?: string;
        type?: string;
      },
    ];
  };
}

export interface IAutoPayFiserveError {
  paymentIndicator: boolean;
  result?: {
    statusCode?: string;
    statusMessages?: {
      type?: string;
      description?: string;
      code?: string;
    }[];
  };
  errorCode?: string;
}
export interface IResponseAutopayDetails {
  errorMessage: string;
  referenceCode?: string;
  referenceId?: string;
  result?: {
    statusCode?: string;
    statusMessages?: [
      {
        code?: string;
        description?: string;
        type?: string;
      },
    ];
  };
}

export interface IResponseUpdateAutopayDetails {
  fundingAccountValidationResult: {
    cardValidationDetail: {
      accountValid: boolean;
      blocked: boolean;
    };
    fundingAccount: IFundingAccount;
    summaryValidationState: string;
  };
  referenceId: string;
  result: {
    statusCode: string;
    statusMessages: [
      {
        code: string;
        description: string;
        type: string;
      },
    ];
  };
}
export interface IFilterWalletErrorResponse {
  errorCode: string;
  errorMessage: string;
  statusCode: string;
}

export interface IFilterWalletResponse {
  errorMessage: string;
  response: {
    walletFundingAccounts: IAutoPayPaymentMethod[];
  };
}
export interface IAutoPayPaymentMethods {
  isLoaded: boolean;
  wallets: IAutoPayPaymentMethod[];
}
//This interface represents the format for binder payment details, name of the interface maybe changed  in the future.
export interface IBinderPaymentMethod {
  fiservResponse: IFiservResponse;
  savePaymentMethod: boolean;
  selectedPaymentMethodType?: string;
  paymentDate: string;
  selectedPaymentAmountType: string;
  paymentAmount: number;
  nickname: string;
  selectedPaymentMethodName?: string; // used for populating wallet types
  emailAddress?: string;
}

export interface IBinderPaymentDetails {
  selectedBillCimNumber?: string;
  selectedCaseNumber?: string;
  exchangeIndicator?: string;
  remainingBinderAmount?: number;
  billNames?: string;
  dueDate?: string;
  upcomingPaymentIndicator?: boolean;
  minimumRequiredPremium?: number;
  applicationId?: string;
  mppId?: number;
}

export interface IAutopayBinderPaymentMethod {
  fiservResponse: IFiservResponse;
  savePaymentMethod: boolean;
  setAutopay: boolean;
  selectedPaymentMethodType?: string;
  selectedPaymentMethodName?: string;
  nickname: string;
  accountHolderEmailAddress: string;
}

export interface IAutoPayPaymentMethod {
  fundingAccountToken: string;
  fundingAccountLastFourDigit: string;
  fundingCategory: string;
  bankAccountType: string;
  nickName: string;
  defaultFundingSourceFlag: boolean;
}
export interface IAutoPaymentsArray {
  fundingAccount: IFundingAccount;
  referenceId?: string;
  referenceCode?: string;
}

export interface IGetAutoPaymentDetails {
  memberPaymentMethod?: string;
  selectedBillNames?: string;
  autoPayment?: IAutoPaymentsArray | null;
  paymentDateStr?: string;
  isNextPaymentDateWithinXDays?: boolean;
  isActive: boolean;
  isAutopayActive?: string;
  billedPremium?: string;
  latePaymentAmount?: string;
  totalAmountDue?: string;
  isOneMonthPaymentRemaining?: boolean;
  isTwoMonthsPaymentRemaining?: boolean;
  emailAddress?: string | null;
  accountHolderEmailAddress?: string | null;
  memberAccountHolderEmail?: string | null;
  applicantAutoPayEmailAddress?: string | null;
  showAutopayLabels?: boolean;
  allowToDisable?: boolean; //This flag is for handling autopayment processing date, if th flag is coming as true allow the user to disable autopay else user cannot disable autopay
  allowToUpdate?: boolean; //This flag is for handling autopayment draft dates, if th flag is coming as true allow the user to update autopay paymentmethod else user cannot update autopay payment method.
}
export interface IGetAutoPaymentResponse {
  errorMessage: string | null;
  response: IGetAutoPaymentDetails;
}

export enum PAYMENT_API_TYPE {
  NONE = 'NONE',
  IMMEDIATE = 'IMMEDIATE',
  SCHEDULED = 'SCHEDULED',
  UPDATED = 'UPDATED',
  CANCELED = 'CANCELED',
}

export interface IAutopayAlertDetails {
  alertMessage?: string;
  showAutopayAlert?: boolean;
  alertType?: ALERT_TYPES;
  redirectToPath?: string; // used to check for reset alert details during unmount
}

export interface IBillingHistorySpreadsheetDetails {
  adjustments: number;
  advancedPremiumTaxCredit: number;
  billPeriod: string;
  billRunDate: string;
  billRunNumber: number;
  billedPremium: number;
  cim: string;
  commissionablePremium: number;
  fees: number;
  paymentsReceived: number;
  priorBalance: number;
  totalAmountDue: number;
  billDeliveryMethod: string;
  currentCharges: number;
  status: string;
  createDate: string;
  billIssuedOn: string;
}

export interface IBillingHistoryViewListDetails
  extends IBillingHistorySpreadsheetDetails {
  billName?: string;
}

export interface IBillHistoryResponse {
  caseNumber: string;
  cim: string;
  billName: string;
  billHistory: IBillingHistorySpreadsheetDetails[];
}

export interface IPaymentHistoryItem {
  paymentStatus: string;
  employerHierarchyIndicator: boolean;
  employerName: string | null;
  transactionDate: string;
  paymentMethod: string;
  accountName: string;
  confirmationNumber: string;
  transactionId: string;
  amount: number;
  transactionType: string;
  dataSource: string;
  cim: string;
  isAutoPayment: boolean;
  scheduledPaymentInfo?: IScheduledPaymentInfo;
  paymentDate: string;
}

export interface IScheduledPaymentInfo {
  fundingAccount: IFundingAccount;
  referenceCode: string;
  referenceId: string;
}

export interface IPaymentHistoryResponse {
  paymentHistoryList: IPaymentHistoryItem[];
  vmsStatusCode: string;
}

export interface IBillOptions {
  [key: string]: string | boolean | undefined;
  billName?: string;
  planName?: string;
  isSelected: boolean;
}

// interface for selected filters for payment history
export interface IPaymentHistoryFilters {
  selectedFilterStatus: (string | undefined)[];
  selectedFilterFromDate: string;
  selectedFilterToDate: string;
  selectedFilterDateRange: number;
}

export interface IPaymentHistoryDetailsForActiveGov {
  getScheduledPaymentRequest?: ISchedulePayments;
  paymentHistProductDetail?: IGovernmentProductDetails;
}

export interface ISubscriberDetails {
  subcriberCimNumber: string;
  subcriberCaseNumber: string;
  subcriberId: string;
  pendingPaymentIndicator: boolean;
  exchangeIndicator: string;
  currentAmountDue: number;
  billDueDate: string;
  delinquentAmount: number;
  currentBillPeriod: string;
  termDate: string;
}
export interface IValidateMemberResponse {
  mid: number;
  memberValidateResponse: string;
  mppId: number;
  dateOfBirth: string;
  zipCode: string;
  previousAutopayEnrolled: boolean;
  subcriberDetails: ISubscriberDetails[];
  state: string;
  govtMember: boolean;
  planBenefitPackageId?: string;
  cmsContractNumber?: string;
}

export interface IBrokerValidateMemberResponse extends IValidateMemberResponse {
  brokerId: string;
  brokerName: string;
  emailId: string;
}

export interface IBrokerDetails {
  brokerId: string;
  brokerName: string;
  brokerEmailId: string;
}

export interface IMemberBillingInfoRequest {
  dateOfBirth: string;
  zipCode: string;
  mid: number;
  subcriberDetails?: ISubscriberDetails[];
  state?: string;
  govtMember?: boolean;
  dataSource?: MEMBER_DATA_SOURCE;
  derivedLob?: MEMBER_DERIVED_LOB;
  planName?: string;
  productDetail?: IGovernmentProductDetails;
  allProductDetails?: IGovernmentProductDetails[];
  planBenefitPackageId?: string;
  cmsContractNumber?: string;
  termedMember?: boolean;
  brokerDetails?: {
    brokerId: string;
    brokerName: string;
    emailId: string;
  };
  policyId?: string;
}

export interface IGpdMemberBillingInfoRequest {
  dateOfBirth: string;
  zipCode: string;
  productDetail?: IGovernmentProductDetails[] | IGovernmentProductDetails;
  mid?: number;
  policyId?: string;
}

export interface IValidateActiveGovMemberResponse {
  planName: string;
  productDetail: IGovernmentProductDetails[];
  dataSource: MEMBER_DATA_SOURCE;
  derivedLob: MEMBER_DERIVED_LOB;
  subcriberId: string;
}

export interface IValidateActiveMemberResponse
  extends IValidateMemberResponse,
    IValidateActiveGovMemberResponse,
    ISubscriberDetails {
  errorCode?: string;
  errorMessage?: string;
  statusCode?: string;
  redirectionParameters?: IHPSRedirectionParams | null;
  redirectionManager?: {
    redirectionIndicators: {
      memberProfileId: string;
      dob: string;
      zipCode: string;
      username: string;
      id: number;
      uid: string;
      carrierCode: string;
      pmiInd: number;
    };
    conversionEligibleState: boolean;
  };
  onboardType?: string;
  billerNotified?: boolean;
  lockdownPeriod: boolean;
  freezePeriod: boolean;
  forcedConvNonAutopay: boolean;
  showAPForcedConverted: boolean; // here AP is Autopay
  termedMember: boolean;
  isRetailAndGovtMember?: boolean; // for the pick your plan screen
  selectedPolicy?: string;
}
export interface IPKCEStatus {
  verifier: string;
  challenge: string;
}

export interface IAuthenticationError {
  showError: boolean;
  authenticationError: boolean;
  errAPIResponse?: APIError;
  errorMessage?: string;
  hoursOfOperation?: string;
}

export interface APIError {
  errorMessage?: string;
  statusCode?: string;
  redirectingToErrorScreen?: boolean;
  stateCode?: string;
  govtMember?: boolean;
  dataSource?: MEMBER_DATA_SOURCE;
  derivedLOB?: MEMBER_DERIVED_LOB;
  errorCode?: string;
}
// interface for selected filters for billing history
export interface IBillingHistoryFilters {
  selectedFilterBillName: (string | undefined)[];
  selectedFilterFromDate: string;
  selectedFilterToDate: string;
  selectedFilterDateRange: number;
  selectedFilterStatus: (string | undefined)[];
}

export interface IFetchWallet {
  headers: IAPIHeaders;
  onSuccess?: () => void;
  onError?: () => void;
  userType?: USER_TYPES;
}

export interface IHPSErrorScreen extends IAEMContentResponseStatus {
  label: {
    errorMessage: string;
  };
}
export interface IBinderPayNowLoginResponse {
  mppId: number;
  binderPaymentStatus: BINDER_PAYMENT_STATUS;
}

export interface IApplicantBinderDetails {
  subscriberCaseNumber?: string;
  subscriberCimNumber?: string;
  planName?: string | null;
  exchangeIndicator?: string;
  applicationId: string;
  mppId: number;
  state?: string;
}

export interface IApplicantBinderDetailsResponse {
  applicantValidationList: IApplicantBinderDetails[];
  effectiveDate: string;
  email: string | null;
}

export interface IBannerComponentProps {
  bannerHeading: string;
  bannerMessage: string;
}

export enum SCHEDULED_EMAIL_ERROR {
  NONE = 'NONE',
  NO_EMAIL = 'NO_EMAIL',
  INVALID_EMAIL = 'INVALID_EMAIL',
}

export interface IGovernmentProductDetails {
  lineOfBusiness?: MEMBER_LINE_OF_BUSINESS;
  productType?: MEMBER_PRODUCT_TYPE;
  coverageType?: string; // For HealthSpring: SHL, DVH, MAPD, PDP
  sourceSystemName?: MEMBER_SOURCE_SYSTEM_NAME;
  corporateEntityCode?: MEMBER_CORPORATE_CODE;
  dataSource?: MEMBER_DATA_SOURCE;
  derivedLob?: MEMBER_DERIVED_LOB;
  planName?: string;
  mppId?: number;
  subcriberId?: string;
  state?: string;
  planBenefitPackageId?: string;
  cmsContractNumber?: string;
  memberId?: string;
  externalPolicyId?: string; // For HealthSpring
  policyId?: string; // Policy identifier (e.g., "5487523^HS1^FDC140012^000^000^20220927")
  planDescription?: string; // For HealthSpring
  memberSystemName?: string; // For HealthSpring
  policyStatus?: string; // Policy status (e.g., "Active", "Terminated")
  effectiveDate?: string; // Policy effective date (e.g., "2022-09-27")
  endDate?: string; // Policy end/termination date (e.g., "2024-03-31")
}

export interface IAEMUserBasedAlertResponse {
  alertMessage: string;
  isAlertMessageRequired: boolean;
  isLoaded: boolean;
}

export interface IPaymentEmailConfirmationHeader {
  PRODUCT_TYPE?: string;
  DATA_SOURCE?: string;
  DERIVED_LOB?: string;
  STATE_CODE?: string;
  MPP_ID: number;
  MEMBER_ID: string;
  USER_TYPE_CODE?: number;
  CONFIRMATION_FLAG?: string;
}

export interface IPaymentEvents {
  status?: PAYMENT_STATUS;
  appliedDate?: string;
}
export interface IRecentPaymentProps {
  paymentAmount: number;
  confirmationNumber?: string | number;
  paymentDate: string;
  paymentMethod: string;
  paymentType: PAYMENT_TYPES;
  paymentEvents: IPaymentEvents[];
  paymentTrackingId?: number;
  scheduledPaymentDetails?: IScheduledTransaction;
}
export interface IRecentPayments {
  listofRecentPayments: IRecentPaymentProps[];
  isLoaded: boolean;
}

export interface IStateEMailErrors {
  IL: string;
  TX: string;
  MT: string;
  OK: string;
  NM: string;
}
